export const categories = [
  { slug: "guochan", name: "国产剧", icon: "ri-flag-2-line" },
  { slug: "hanju", name: "韩剧", icon: "ri-heart-pulse-line" },
  { slug: "meiju", name: "美剧", icon: "ri-earth-line" },
  { slug: "riju", name: "日剧", icon: "ri-sun-line" },
  { slug: "taiju", name: "泰剧", icon: "ri-heart-line" },
  { slug: "dongman", name: "动漫", icon: "ri-movie-2-line" },
];

export interface DramaEpisode {
  num: number;
  title: string;
  duration: string;
}

export interface Drama {
  id: number;
  title: string;
  subtitle: string;
  category: string;
  rating: number;
  year: number;
  region: string;
  episodes: number;
  status: string;
  description: string;
  coverImage: string;
  bannerImage: string;
  cast: string[];
  director: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  episodeList: DramaEpisode[];
  relatedIds: number[];
}

export const dramas: Drama[] = [
  {
    id: 1,
    title: "长安十二时辰",
    subtitle: "The Longest Day in Chang'an",
    category: "guochan",
    rating: 8.2,
    year: 2019,
    region: "中国大陆",
    episodes: 48,
    status: "已完结",
    description: "唐朝天宝三年，上元节前夕，长安城陷入一场巨大的危机之中。死囚张小敬临危受命，与李必携手在十二时辰内拯救长安城的故事。该剧以精致的服化道和紧凑的剧情获得了观众的一致好评，被誉为国产古装悬疑剧的标杆之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20Tang%20Dynasty%20warrior%20in%20ancient%20Changan%20city%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20film%20poster%20style%2C%20clean%20background&width=600&height=840&seq=drama-cover-1&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20city%20Changan%20at%20night%20with%20lanterns%2C%20Tang%20Dynasty%20aesthetic%2C%20cinematic%20wide%20shot%2C%20warm%20golden%20atmosphere%2C%20dramatic%20lighting%2C%20film%20grade%20color%20grading%2C%20atmospheric%20moody%20composition&width=1600&height=600&seq=drama-banner-1&orientation=landscape",
    cast: ["雷佳音", "易烊千玺", "周一围", "芦芳生", "热依扎"],
    director: "曹盾",
    tags: ["古装", "悬疑", "历史", "动作"],
    isHot: true,
    isNew: false,
    updateInfo: "全48集",
    episodeList: Array.from({ length: 48 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "45分钟",
    })),
    relatedIds: [2, 5, 9],
  },
  {
    id: 2,
    title: "狂飙",
    subtitle: "The Knockout",
    category: "guochan",
    rating: 8.5,
    year: 2023,
    region: "中国大陆",
    episodes: 39,
    status: "已完结",
    description: "讲述了以一线刑警安欣为代表的正义力量，与黑恶势力长达二十年的生死较量。通过群像叙事展现扫黑行动中的复杂人性与社会变迁，剧情扣人心弦，演员演技炸裂，成为近年来现象级的国产电视剧。",
    coverImage: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%20with%20two%20men%20facing%20off%2C%20police%20versus%20gangster%2C%20intense%20noir%20style%2C%20dark%20moody%20tones%2C%20Chinese%20modern%20crime%20drama%2C%20film%20poster%20design%2C%20clean%20composition&width=600&height=840&seq=drama-cover-2&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20night%20scene%20with%20police%20lights%2C%20urban%20landscape%2C%20crime%20drama%20atmosphere%2C%20dark%20and%20moody%20cinematic%20wide%20shot%2C%20film%20noir%20style%2C%20dramatic%20lighting&width=1600&height=600&seq=drama-banner-2&orientation=landscape",
    cast: ["张译", "张颂文", "李一桐", "张志坚", "吴刚"],
    director: "徐纪周",
    tags: ["刑侦", "扫黑", "悬疑", "都市"],
    isHot: true,
    isNew: false,
    updateInfo: "全39集",
    episodeList: Array.from({ length: 39 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "45分钟",
    })),
    relatedIds: [1, 6, 7],
  },
  {
    id: 3,
    title: "黑暗荣耀",
    subtitle: "The Glory",
    category: "hanju",
    rating: 8.9,
    year: 2022,
    region: "韩国",
    episodes: 16,
    status: "已完结",
    description: "文东恩在高中时期遭受校园暴力后退学，多年后她成为加害者孩子的班主任，展开了一场精心策划的复仇计划。宋慧乔的精湛演技与金恩淑编剧的细腻笔触，让这部复仇剧成为韩剧新经典。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%2C%20elegant%20woman%20in%20dark%20attire%2C%20mysterious%20atmosphere%2C%20cool%20toned%20cinematic%20lighting%2C%20Korean%20drama%20film%20poster%20style%2C%20minimalist%20design%2C%20clean%20background&width=600&height=840&seq=drama-cover-3&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20winter%20scene%20with%20snow%2C%20modern%20Seoul%20architecture%2C%20cold%20atmospheric%20tone%2C%20cinematic%20wide%20composition%2C%20Korean%20drama%20aesthetic%2C%20moody%20lighting&width=1600&height=600&seq=drama-banner-3&orientation=landscape",
    cast: ["宋慧乔", "李到晛", "林智妍", "廉惠兰", "朴成焄"],
    director: "安吉镐",
    tags: ["复仇", "校园暴力", "悬疑", "剧情"],
    isHot: true,
    isNew: false,
    updateInfo: "全16集",
    episodeList: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "50分钟",
    })),
    relatedIds: [4, 12, 8],
  },
  {
    id: 4,
    title: "眼泪女王",
    subtitle: "Queen of Tears",
    category: "hanju",
    rating: 8.3,
    year: 2024,
    region: "韩国",
    episodes: 16,
    status: "已完结",
    description: "财阀千金洪海仁与普通家庭出身的白贤宇结婚三年后遭遇婚姻危机，两人在克服困难的过程中重新找回爱情的故事。金秀贤与金智媛的组合带来了极高的话题度和收视率。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%20with%20elegant%20couple%2C%20luxury%20aesthetic%2C%20warm%20romantic%20tones%2C%20Korean%20drama%20film%20poster%20style%2C%20soft%20lighting%2C%20clean%20composition%2C%20emotional%20atmosphere&width=600&height=840&seq=drama-cover-4&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20garden%20scene%20with%20flowers%2C%20luxury%20estate%20background%2C%20soft%20warm%20sunlight%2C%20cinematic%20wide%20shot%2C%20Korean%20romance%20drama%20aesthetic%2C%20dreamy%20atmosphere&width=1600&height=600&seq=drama-banner-4&orientation=landscape",
    cast: ["金秀贤", "金智媛", "朴成焄", "郭东延", "李主傧"],
    director: "张英宇",
    tags: ["爱情", "财阀", "婚姻", "治愈"],
    isHot: true,
    isNew: true,
    updateInfo: "全16集",
    episodeList: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "60分钟",
    })),
    relatedIds: [3, 8, 10],
  },
  {
    id: 5,
    title: "琅琊榜",
    subtitle: "Nirvana in Fire",
    category: "guochan",
    rating: 9.3,
    year: 2015,
    region: "中国大陆",
    episodes: 54,
    status: "已完结",
    description: "十二年前七万赤焰军被奸人所害含冤埋骨梅岭，少帅林殊侥幸生还。十二年后他化名梅长苏重返帝都，以病弱之躯拨开重重迷雾，扶持明君，昭雪冤案。该剧被誉为中国电视剧史上的里程碑之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20scholar%20in%20flowing%20robes%20against%20ink%20wash%20painting%20style%20background%2C%20elegant%20classical%20Chinese%20aesthetic%2C%20warm%20neutral%20tones%2C%20film%20poster%20design&width=600&height=840&seq=drama-cover-5&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20plum%20blossoms%2C%20classical%20architecture%2C%20ink%20wash%20painting%20atmosphere%2C%20elegant%20Chinese%20aesthetic%2C%20cinematic%20wide%20composition%2C%20soft%20misty%20lighting&width=1600&height=600&seq=drama-banner-5&orientation=landscape",
    cast: ["胡歌", "刘涛", "王凯", "黄维德", "陈龙"],
    director: "孔笙",
    tags: ["古装", "权谋", "历史", "剧情"],
    isHot: true,
    isNew: false,
    updateInfo: "全54集",
    episodeList: Array.from({ length: 54 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "45分钟",
    })),
    relatedIds: [1, 9, 11],
  },
  {
    id: 6,
    title: "繁花",
    subtitle: "Blossoms Shanghai",
    category: "guochan",
    rating: 8.7,
    year: 2023,
    region: "中国大陆",
    episodes: 30,
    status: "已完结",
    description: "以上世纪九十年代初的上海为背景，讲述阿宝在改革开放浪潮中从普通青年成长为商界大佬的传奇人生。王家卫导演的首部电视剧作品，以极致的视觉美学和深刻的人物刻画获得了广泛赞誉。",
    coverImage: "https://readdy.ai/api/search-image?query=Shanghai%201990s%20drama%20poster%2C%20stylish%20man%20in%20vintage%20suit%2C%20neon%20lights%20and%20retro%20atmosphere%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20golden%20and%20warm%20tones%2C%20film%20poster%20design%2C%20clean%20composition&width=600&height=840&seq=drama-cover-6&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Shanghai%20Bund%20at%20night%20in%201990s%2C%20neon%20signs%20and%20vintage%20cars%2C%20retro%20Chinese%20atmosphere%2C%20cinematic%20wide%20shot%2C%20golden%20warm%20lighting%2C%20nostalgic%20mood&width=1600&height=600&seq=drama-banner-6&orientation=landscape",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾", "游本昌"],
    director: "王家卫",
    tags: ["年代", "商战", "上海", "剧情"],
    isHot: true,
    isNew: true,
    updateInfo: "全30集",
    episodeList: Array.from({ length: 30 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "50分钟",
    })),
    relatedIds: [2, 7, 1],
  },
  {
    id: 7,
    title: "漫长的季节",
    subtitle: "The Long Season",
    category: "guochan",
    rating: 9.0,
    year: 2023,
    region: "中国大陆",
    episodes: 12,
    status: "已完结",
    description: "一桩跨越二十年的悬案，将出租车司机王响、退休刑警马德胜等人重新聚在一起。在东北小镇的暮色中，他们剥开层层迷雾，寻找真相。辛爽导演用诗意的镜头语言，讲述了一个关于时间与人性的深刻故事。",
    coverImage: "https://readdy.ai/api/search-image?query=Northeast%20China%20mystery%20drama%20poster%2C%20middle%20aged%20man%20in%20winter%20coat%20against%20snowy%20industrial%20background%2C%20moody%20atmospheric%20tone%2C%20Chinese%20art%20film%20style%2C%20dark%20warm%20colors%2C%20minimalist%20design&width=600&height=840&seq=drama-cover-7&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20town%20in%20autumn%2C%20old%20factory%20buildings%2C%20golden%20leaves%2C%20nostalgic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20melancholic%20lighting%2C%20Chinese%20indie%20film%20aesthetic&width=1600&height=600&seq=drama-banner-7&orientation=landscape",
    cast: ["范伟", "秦昊", "陈明昊", "李庚希", "刘琳"],
    director: "辛爽",
    tags: ["悬疑", "犯罪", "年代", "剧情"],
    isHot: true,
    isNew: false,
    updateInfo: "全12集",
    episodeList: Array.from({ length: 12 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "60分钟",
    })),
    relatedIds: [2, 6, 1],
  },
  {
    id: 8,
    title: "与恶魔有约",
    subtitle: "My Demon",
    category: "hanju",
    rating: 8.1,
    year: 2023,
    region: "韩国",
    episodes: 16,
    status: "已完结",
    description: "冷酷的恶魔郑九元因意外失去能力，不得不与财阀继承人陶道熙签订契约结婚。两人从针锋相对到渐生情愫，上演了一出奇幻浪漫的爱情喜剧。宋江与金裕贞的高颜值组合让这部剧甜度爆表。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20drama%20poster%2C%20handsome%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20elegant%20dress%2C%20dark%20romantic%20atmosphere%2C%20mystical%20elements%2C%20Korean%20drama%20film%20poster%20style%2C%20clean%20composition&width=600&height=840&seq=drama-cover-8&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20city%20night%20scene%20with%20sparkling%20lights%2C%20luxury%20hotel%20background%2C%20fantasy%20atmosphere%2C%20cinematic%20wide%20shot%2C%20Korean%20romance%20drama%20aesthetic%2C%20dreamy%20lighting&width=1600&height=600&seq=drama-banner-8&orientation=landscape",
    cast: ["宋江", "金裕贞", "李相二", "金海淑", "赵慧珠"],
    director: "金章汉",
    tags: ["奇幻", "爱情", "喜剧", "契约婚姻"],
    isHot: false,
    isNew: true,
    updateInfo: "全16集",
    episodeList: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "60分钟",
    })),
    relatedIds: [3, 4, 10],
  },
  {
    id: 9,
    title: "庆余年",
    subtitle: "Joy of Life",
    category: "guochan",
    rating: 8.4,
    year: 2019,
    region: "中国大陆",
    episodes: 46,
    status: "第二季已完结",
    description: "一个拥有现代记忆的少年范闲，穿越到古代庆国，在复杂的权力斗争中步步为营，开启了一段传奇人生。该剧以独特的幽默风格和烧脑的权谋剧情征服了无数观众。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20historical%20drama%20poster%2C%20young%20man%20in%20ancient%20Chinese%20robes%20with%20sword%2C%20epic%20adventure%20vibe%2C%20warm%20golden%20and%20crimson%20tones%2C%20film%20poster%20design%2C%20dramatic%20composition&width=600&height=840&seq=drama-cover-9&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20and%20mountain%20landscape%2C%20epic%20fantasy%20atmosphere%2C%20golden%20sunset%20lighting%2C%20cinematic%20wide%20shot%2C%20Chinese%20historical%20drama%20aesthetic%2C%20grand%20composition&width=1600&height=600&seq=drama-banner-9&orientation=landscape",
    cast: ["张若昀", "李沁", "陈道明", "吴刚", "辛芷蕾"],
    director: "孙皓",
    tags: ["古装", "穿越", "权谋", "喜剧"],
    isHot: true,
    isNew: false,
    updateInfo: "更新至46集",
    episodeList: Array.from({ length: 46 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "45分钟",
    })),
    relatedIds: [1, 5, 11],
  },
  {
    id: 10,
    title: "背着善宰跑",
    subtitle: "Lovely Runner",
    category: "hanju",
    rating: 8.6,
    year: 2024,
    region: "韩国",
    episodes: 16,
    status: "已完结",
    description: "因事故瘫痪的粉丝林率，在偶像柳善宰去世后意外穿越回过去。她决心改变命运拯救善宰，却在一次次穿越中发现了隐藏的真相与深埋的爱意。边佑锡与金惠允的化学反应让无数观众为之疯狂。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20time%20travel%20romance%20drama%20poster%2C%20young%20couple%20running%20together%2C%20youthful%20and%20vibrant%20energy%2C%20warm%20spring%20tones%2C%20Korean%20drama%20film%20poster%20style%2C%20clean%20bright%20composition&width=600&height=840&seq=drama-cover-10&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Korean%20spring%20cherry%20blossom%20road%2C%20young%20couple%20silhouette%20running%2C%20warm%20sunlight%20and%20petals%2C%20cinematic%20wide%20shot%2C%20Korean%20youth%20drama%20aesthetic%2C%20dreamy%20romantic%20atmosphere&width=1600&height=600&seq=drama-banner-10&orientation=landscape",
    cast: ["边佑锡", "金惠允", "宋建熙", "李承协"],
    director: "金泰烨",
    tags: ["穿越", "爱情", "青春", "治愈"],
    isHot: true,
    isNew: true,
    updateInfo: "全16集",
    episodeList: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "60分钟",
    })),
    relatedIds: [3, 4, 8],
  },
  {
    id: 11,
    title: "三体",
    subtitle: "Three-Body",
    category: "guochan",
    rating: 8.0,
    year: 2023,
    region: "中国大陆",
    episodes: 30,
    status: "已完结",
    description: "根据刘慈欣同名科幻小说改编，讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼与刑警史强共同揭开地外文明三体世界的神秘面纱，并随之与全人类共同面对即将到来的危机的故事。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20mysterious%20cosmic%20background%20with%20three%20suns%2C%20futuristic%20yet%20grounded%20aesthetic%2C%20dark%20blue%20and%20gold%20tones%2C%20film%20poster%20design%2C%20clean%20composition&width=600&height=840&seq=drama-cover-11&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Cosmic%20space%20with%20three%20stars%20and%20distant%20planet%2C%20sci-fi%20atmosphere%2C%20mysterious%20and%20vast%2C%20cinematic%20wide%20shot%2C%20dark%20and%20contemplative%20mood%2C%20scientific%20observatory%20silhouette&width=1600&height=600&seq=drama-banner-11&orientation=landscape",
    cast: ["张鲁一", "于和伟", "陈瑾", "王子文", "林永健"],
    director: "杨磊",
    tags: ["科幻", "悬疑", "改编", "剧情"],
    isHot: false,
    isNew: false,
    updateInfo: "全30集",
    episodeList: Array.from({ length: 30 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "45分钟",
    })),
    relatedIds: [1, 9, 7],
  },
  {
    id: 12,
    title: "请回答1988",
    subtitle: "Reply 1988",
    category: "hanju",
    rating: 9.7,
    year: 2015,
    region: "韩国",
    episodes: 20,
    status: "已完结",
    description: "以1988年首尔双门洞为背景，讲述五个家庭的温馨故事和五个青梅竹马伙伴的成长与青春。没有狗血剧情，只有温暖的邻里情、亲情、友情和青涩的爱情，被誉为治愈系韩剧天花板。",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%201980s%20retro%20family%20drama%20poster%2C%20five%20teenagers%20sitting%20together%20in%20vintage%20clothes%2C%20warm%20nostalgic%20tones%2C%20Korean%20drama%20film%20poster%20style%2C%20cozy%20atmosphere%2C%20clean%20composition&width=600&height=840&seq=drama-cover-12&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Korean%201980s%20neighborhood%20alley%20with%20old%20houses%2C%20warm%20sunset%20lighting%2C%20nostalgic%20retro%20atmosphere%2C%20cinematic%20wide%20shot%2C%20cozy%20Korean%20drama%20aesthetic%2C%20heartwarming%20mood&width=1600&height=600&seq=drama-banner-12&orientation=landscape",
    cast: ["李惠利", "朴宝剑", "柳俊烈", "高庚杓", "李东辉"],
    director: "申元浩",
    tags: ["家庭", "青春", "怀旧", "喜剧"],
    isHot: true,
    isNew: false,
    updateInfo: "全20集",
    episodeList: Array.from({ length: 20 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      duration: "90分钟",
    })),
    relatedIds: [3, 10, 8],
  },
];

export function getDramasByCategory(slug: string): Drama[] {
  return dramas.filter((d) => d.category === slug);
}

export function getHotDramas(): Drama[] {
  return dramas.filter((d) => d.isHot);
}

export function getNewDramas(): Drama[] {
  return dramas.filter((d) => d.isNew);
}

export function getDramaById(id: number): Drama | undefined {
  return dramas.find((d) => d.id === id);
}

export function getRelatedDramas(drama: Drama): Drama[] {
  return drama.relatedIds.map((id) => dramas.find((d) => d.id === id)).filter(Boolean) as Drama[];
}

export function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}